if (!customElements.get("bundle-item")) {
  const registeredSections = new Set();

  class BundleItem extends HTMLElement {
    constructor() {
      super();
      this.onInputChange = this.onInputChange.bind(this);
    }

    connectedCallback() {
      this.input = this.querySelector("input");
      this.input.addEventListener("change", this.onInputChange);
      this._registerVariantChangeListener();
    }

    disconnectedCallback() {
      this.input.removeEventListener("change", this.onInputChange);
    }

    _registerVariantChangeListener() {
      const sectionId = this.dataset.section;
      if (registeredSections.has(sectionId)) return;
      registeredSections.add(sectionId);

      document.addEventListener(
        `eurus:product-page-variant-select:updated:${sectionId}`,
        (event) => {
          const html = event.detail.html;
          if (!html) return;

          const bundlesContainer = document.getElementById(
            `bundles-${sectionId}`,
          );
          if (!bundlesContainer) return;

          const source = html.getElementById(`bundles-${sectionId}`);
          if (source) {
            bundlesContainer.innerHTML = source.innerHTML;
          }
        },
      );
    }

    onInputChange(event) {
      const bundleVariantID = event.target.value;

      // Update the main product form's variant ID
      const variantInput = document.getElementById(
        `update-variant-${this.dataset.section}`,
      );
      if (variantInput) variantInput.value = bundleVariantID;

      this.renderProductInfo(bundleVariantID);
    }

    renderProductInfo(bundleVariantID) {
      if (!bundleVariantID) return;

      fetch(
        `${this.dataset.url}?variant=${bundleVariantID}&section_id=${this.dataset.section}`,
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );

          // Update price
          const priceDestination = document.getElementById(
            `price-${this.dataset.section}`,
          );
          const priceSource = html.getElementById(
            `price-${this.dataset.section}`,
          );
          if (priceSource && priceDestination)
            priceDestination.innerHTML = priceSource.innerHTML;
        });
    }
  }

  customElements.define("bundle-item", BundleItem);
}
